// extracted by css-extract-rspack-plugin
export default {"createToken":"Kg_AZh7zUL4t4FmG"};